import { filterTypeRegistry } from '@intelligence/v3/filterCore/registry';
import { FILTER_CONTROL_ADAPTERS } from './controlAdapters';

export const registerBuiltInControls = (): void => {
  FILTER_CONTROL_ADAPTERS.forEach((control) => {
    filterTypeRegistry.register(control.type, {
      ...control.entry,
      getRenderPreview: control.getRenderPreview,
      normalizeValue: control.normalizeValue,
    });
  });
};

registerBuiltInControls();
